import React, {useMemo, useContext, useCallback} from "react";
import { useLocation } from "react-router-dom";
import _ from "lodash";
import { Container, Col, Row } from "react-bootstrap";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import StitchList from "./StitchList";
import DraggableItem from "../drag-drop/DraggableItem";
import { RequestContext } from "../../context/RequestContext";
import { DoubleArrow } from "@material-ui/icons";
import './request.scss';

const Stitch = ({ isDraft }) => {
  const {
    sources,
    stitchAssetName,
    stitchedKeys,
    stitchingError,
    stitchAssetNameError,
    setStitchAssetName,
    setStitchedKeys
  } = useContext(RequestContext);
  const { search } = useLocation();
  const isJobEditPage = useMemo(() => new URLSearchParams(search).get("jobId"), [search]);

  const onStitchAssetNameChange = useCallback((e) => {
    const assetName = e.target.value;
    setStitchAssetName(assetName);
  }, [setStitchAssetName]);

  return (
    <DndProvider backend={HTML5Backend}>
        <Container
            className="stitchContainer"
            style={{
                pointerEvents: isJobEditPage ? "none" : "all",
                opacity: isJobEditPage ? 0.6 : 1  }}>
            <Row>
              <Col xs={3}>
                <div className="form-group stitch-name">
                  <label className="stitchLabel">Stitched Asset Name</label>
                  <input
                      className="stitchInput"
                      type="text"
                      required={true}
                      disabled={!isDraft}
                      value={stitchAssetName}
                      onChange={onStitchAssetNameChange}
                      style={{ borderColor: stitchAssetNameError && 'red' }}
                  />
                </div>
              </Col>
            </Row>
            <Row>
                <Col xs={3}>
                    <Row className="stitchHeaderRow">
                        <label className="stitchHeaderLarge">Source Assets</label>
                        <label className="stitchHeaderSmall">(Drag below asset(s) to Stitched Assets)</label>
                    </Row>
                    {sources && sources.length > 0 && (
                        <ul className="dragItemsUl">
                        {
                            _.map(sources, (source, index) => {
                                let isMapped = stitchedKeys.includes(_.get(source, "key"));
                                return (
                                    <li
                                        key={"stitch-list" + index}
                                        className="listStyleNone">
                                      <DraggableItem
                                          key={"draggable-" + index}
                                          data={{ sources: [source] }}
                                          canDrag={isDraft && !isMapped}
                                          title={source.assetName}
                                          isError={stitchingError && !isMapped}
                                          isMapped={isMapped}
                                          nonEditable
                                          noScroll
                                          novalidation="true"
                                      />
                                    </li>
                                );
                            })
                        }
                    </ul>
                    )}
                </Col>
                <Col className="stitchDoubleArrowCol">
                  <DoubleArrow className="stitchDoubleArrow"/>
                </Col>
                <Col xs={8}>
                    <div>
                        <Row className="stitchHeaderRow">
                            <label className="stitchHeaderLarge">Stitched Assets</label>
                            <label className="stitchHeaderSmall">(Drag below source asset(s) to reorder stitching)</label>
                        </Row>
                        <div className="marginBottomAdd">
                            <StitchList
                                summaryFields={[]}
                                canDrag={isDraft}
                                sources={sources}
                                stitchedKeys={stitchedKeys}
                                onStitchChange={setStitchedKeys}
                            />
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    </DndProvider>
  );
};

export default React.memo(Stitch);
